var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _circle, _circle2, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWomanWithMobileYellowIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 90,
  height: 90,
  "data-name": "Layer 1",
  viewBox: "0 0 876.972 744"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "M515 191h-26a5.006 5.006 0 0 1-5-5v-26a5.006 5.006 0 0 1 5-5h26a5.006 5.006 0 0 1 5 5v26a5.006 5.006 0 0 1-5 5m-26-34a3.003 3.003 0 0 0-3 3v26a3.003 3.003 0 0 0 3 3h26a3.003 3.003 0 0 0 3-3v-26a3.003 3.003 0 0 0-3-3ZM212 36h-26a5.006 5.006 0 0 1-5-5V5a5.006 5.006 0 0 1 5-5h26a5.006 5.006 0 0 1 5 5v26a5.006 5.006 0 0 1-5 5M186 2a3.003 3.003 0 0 0-3 3v26a3.003 3.003 0 0 0 3 3h26a3.003 3.003 0 0 0 3-3V5a3.003 3.003 0 0 0-3-3Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "M499 178h-26a5.006 5.006 0 0 1-5-5v-26a5.006 5.006 0 0 1 5-5h26a5.006 5.006 0 0 1 5 5v26a5.006 5.006 0 0 1-5 5m-26-34a3.003 3.003 0 0 0-3 3v26a3.003 3.003 0 0 0 3 3h26a3.003 3.003 0 0 0 3-3v-26a3.003 3.003 0 0 0-3-3ZM47 395H21a5.006 5.006 0 0 1-5-5v-26a5.006 5.006 0 0 1 5-5h26a5.006 5.006 0 0 1 5 5v26a5.006 5.006 0 0 1-5 5m-26-34a3.003 3.003 0 0 0-3 3v26a3.003 3.003 0 0 0 3 3h26a3.003 3.003 0 0 0 3-3v-26a3.003 3.003 0 0 0-3-3Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "M31 382H5a5.006 5.006 0 0 1-5-5v-26a5.006 5.006 0 0 1 5-5h26a5.006 5.006 0 0 1 5 5v26a5.006 5.006 0 0 1-5 5M5 348a3.003 3.003 0 0 0-3 3v26a3.003 3.003 0 0 0 3 3h26a3.003 3.003 0 0 0 3-3v-26a3.003 3.003 0 0 0-3-3Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M92.43 86.039h240.615a51.15 51.15 0 0 1 49.898 39.9L504.52 665.206a41.34 41.34 0 0 1-38.294 50.383l-247.354 12.187a54.615 54.615 0 0 1-56.43-44.828L93.475 301.68l-5.131 1.466-13.196-72.264 5.281-1.32-19.25-106.426a31.493 31.493 0 0 1 31.25-37.097"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M301.368 97.664h28.087a35.35 35.35 0 0 1 34.536 27.813L480.69 660.345a21.903 21.903 0 0 1-19.968 26.525l-246.554 16.16a28.367 28.367 0 0 1-29.772-23.278l-99.58-552.838a24.846 24.846 0 0 1 24.452-29.25h26.645a11.726 11.726 0 0 1 11.323 8.677 10.35 10.35 0 0 0 9.996 7.66h126.493a17.695 17.695 0 0 0 17.643-16.337"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffbd01",
  d: "M104 188.606h267.476L399.971 317 129 322zM358 431.754h62.971l2 12.055H360z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "m142.17 375.912 267.065-5.656.027 1.257-267.066 5.656zM145.311 413.615l272.091-6.284.03 1.257-272.092 6.284z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffbd01",
  d: "M384 560.754h62.971l2 12.055H386z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "m168.17 504.912 267.065-5.656.027 1.257-267.066 5.656zM171.311 542.615l272.091-6.284.03 1.257-272.092 6.284z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#a0616a",
  d: "m615.56 731.207-11.915-.001-5.668-45.957 17.585.001z"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "m618.598 742.757-38.418-.002v-.486a14.954 14.954 0 0 1 14.953-14.953H618.6Z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#a0616a",
  d: "m763.576 723.405-11.597 2.731-16.053-43.434 17.117-4.031z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "m769.182 733.95-37.396 8.807-.112-.473a14.954 14.954 0 0 1 11.128-17.984l22.84-5.378ZM613.125 537.366c.023-2.395.732-58.915 16.225-80.286l.23-.315 53.991 7.448-1.207 11.863c2.375 2.31 21.055 21.83 26.449 68.054l57.308 153.915-26.642 2.421-78.866-168.017-41.735 182.635h-26.411Z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccc",
  d: "m623.025 459.165 5.278-27.708c-1.033-1.33-5.611-7.717-4.592-15.204.664-4.885 3.58-9.168 8.668-12.734l13.68-31.92.184-.108c.921-.543 22.703-13.138 34.577-1.255.297.23 29.533 23.438 17.793 54.746l-14.494 43.485Z"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#a0616a",
  d: "M604.663 496.652a9.798 9.798 0 0 0 8.275-12.54l28.25-20.354-16.911-6.433-24.235 20.315a9.851 9.851 0 0 0 4.62 19.012"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccc",
  d: "m609.855 463.725 43.13-33.98-12.822-43.81a15.74 15.74 0 0 1 1.589-12.457 14.56 14.56 0 0 1 9.546-6.89c7.383-1.563 14.086 2.571 19.917 12.29l.045.087c.964 2.358 23.433 57.901 6.277 69.779-16.783 11.619-55.7 28.532-56.091 28.703l-.456.197Z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 667.177,
  cy: 332.556,
  r: 26.128,
  fill: "#a0616a"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 708.139,
  cy: 300.114,
  r: 23.114,
  fill: "#2f2e41"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M728.076 319.255a23.116 23.116 0 0 1-35.695-12.137 23.116 23.116 0 1 0 45.09-9.48 23.11 23.11 0 0 1-9.395 21.617"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M636.857 319.28c4.035-7.224 5.579-10.242 10.782-14.635 4.6-3.885 10.26-5.026 14.824-1.344a27.336 27.336 0 1 1-16.494 25.092 28 28 0 0 1 .187-3.091c-3.968-.557-5.332-5.465-9.3-6.022"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M875.972 744h-381a1 1 0 0 1 0-2h381a1 1 0 0 1 0 2"
})));
export default SvgWomanWithMobileYellowIcon;